import styled from 'styled-components';

export const ContentContainer = styled.div`
  height: 100%;
  margin: auto;
  max-width: 1200px;
  width: 85vw;
`;